"use client";

import { useState } from "react";

interface Recipe {
  name: string;
  gram_in: number;
  gram_out: number;
  time: number;
  temp: number;
  grind_setting: number;
  link: string;
}

interface Props {
  brand: string;
  recipes: Recipe[];
}

/**
 * Display temp setting in 4 dots 4 dots should always been shown none selected should have an lesser opacity
 * @param temp
 */
function TempSettings({ temp }: { temp: number }) {
  return (
    <span className="flex gap-1">
      {[1, 2, 3, 4].map((dot) => (
        <span
          key={dot}
          className={`h-4 w-4 rounded-full ${
            dot <= temp ? "bg-white" : "bg-gray-600"
          }`}
        ></span>
      ))}
    </span>
  );
}

export default function RecipeCards({ brand, recipes }: Props) {
  const [selectedRecipe, setSelectedRecipe] = useState<string>("");

  function onClick(recipeName: string) {
    if (selectedRecipe === recipeName) {
      setSelectedRecipe("");
      return;
    }

    setSelectedRecipe(recipeName);
  }

  return (
    <div className="w-full divide-y flex flex-col gap-4">
      <h2 className="text-2xl pb-4 ">{brand}</h2>

      {recipes.map((recipe) => (
        <div key={recipe.name} className="flex flex-col gap-4 pb-4">
          <h3 className="" onClick={() => onClick(recipe.name)}>
            {recipe.name} {selectedRecipe === recipe.name ? "↑" : "↓"}
          </h3>

          {selectedRecipe === recipe.name && (
            <div className="flex flex-col gap-2 recipes">
              <p>In: {recipe.gram_in} gram</p>
              <p>Uit: {recipe.gram_out} gram</p>
              <p>Tijd (seconden): {recipe.time}</p>
              <p className="flex gap-2 items-center">
                Temp (instelling): <TempSettings temp={recipe.temp} />{" "}
              </p>
              <p>Maal stand: {recipe.grind_setting}</p>
              <a
                target="_blank"
                href={recipe.link}
                className="bg-white mt-4 p-2 text-black text-center"
              >
                Kopen
              </a>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
